import React, { Component } from 'react';
import { Badge, Nav, NavItem, NavLink, Row, TabContent, TabPane, Button, Card, CardBody, CardHeader, Col, CardFooter, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import classnames from 'classnames';
import toast from '../../../components/ErrorHandler/toast.js';
import AxiosInstance from '../../../components/AxiosInstance/AxiosInstance';
import Language from '../../../components/Language/Language';
import {
  SortingState, SearchState,
  SummaryState, IntegratedSummary,
  PagingState, CustomPaging, DataTypeProvider, EditingState, CustomSummary,
  SelectionState, IntegratedSelection
} from '@devexpress/dx-react-grid';
import {
  Grid, Table, TableHeaderRow, Toolbar, SearchPanel, PagingPanel, TableEditRow, TableSelection, TableSummaryRow, TableEditColumn,
  ColumnChooser, TableColumnVisibility, DragDropProvider, TableColumnReordering
} from '@devexpress/dx-react-grid-bootstrap4';
import { Loading } from '../../../components/DataGrid/theme-sources/bootstrap4/components/loading';
import pageSizes from '../../../common/data_grid_page_sizes';
import Select from 'react-select';

const formatlessSummaryTypes = ['count'];

const messages = {
  count: 'Total',
};

class BCMProfile extends Component {

  constructor(props) {
    super(props);
    this.ref = React.createRef();

    this.state = {
      columns: [
        { name: 'rowNumber', title: Language.GetLanguageByID(35.01) },
        { name: 'levelName', title: Language.GetLanguageByID(8248.01) },
        { name: 'departmentName', title: Language.GetLanguageByID(9536.01) },
        { name: 'hod', title: Language.GetLanguageByID(2417.01) },
        { name: 'leaders', title: Language.GetLanguageByID(9487.01) },
        { name: 'deputies', title: Language.GetLanguageByID(9506.01) },
        { name: 'internalReportingDueDate', title: Language.GetLanguageByID(2138.01) },
        { name: 'status', title: Language.GetLanguageByID(86.01) },
        { name: 'lastUpdatedDate', title: Language.GetLanguageByID(5791.01) },
        { name: 'lastUpdatedBy', title: Language.GetLanguageByID(5792.01) },
      ],
      columnOrder: ['rowNumber', 'levelName', 'departmentName', 'hod', 'leaders', 'deputies', 'internalReportingDueDate', 'status', 'lastUpdatedDate', 'lastUpdatedBy'],
      //hiddenColumnNames: [],
      tableColumnExtensions: [
        { columnName: 'levelName', wordWrapEnabled: true },
        { columnName: 'departmentName', wordWrapEnabled: true },
        { columnName: 'hod', wordWrapEnabled: true },
        { columnName: 'leaders', wordWrapEnabled: true },
        { columnName: 'deputies', wordWrapEnabled: true },
        { columnName: 'internalReportingDueDate', wordWrapEnabled: true },
        { columnName: 'status', wordWrapEnabled: true },
        { columnName: 'lastUpdatedDate', wordWrapEnabled: true },
        { columnName: 'lastUpdatedBy', wordWrapEnabled: true },
        { columnName: 'rowNumber', width: 100 },
      ],
      rows: [],
      filtertable_data: [],
      totalCount: 0,
      column_name: "tbBCMmDepartmentID",
      order_by: "asc",
      currentPage: 0,
      pageSize: pageSizes.pageSize,
      pageSizes: pageSizes.pageSizes,
      filters: '',
      tbSYSmDomainServerID: 0,
      totalSummaryItems: [
        { columnName: 'rowNumber', type: 'count' }
      ],
      tbBCMmDepartmentID: sessionStorage.getItem('NewQRadar_Dashboard_SelectedDepartmentID') == null ? 0 : sessionStorage.getItem('NewQRadar_Dashboard_SelectedDepartmentID'),
      tbSYSmUserID: 0,
      modalreport: false,
      ddlreporttype: [{ id: 'pdf', name: "PDF" }, { id: 'excel', name: "Excel" }],
      ddlreporttypeselectedvalue: '',
      hiddenColumnNames: ['internalReportingDueDate', 'status', 'lastUpdatedDate', 'lastUpdatedBy'],
      seconds: 0
    }
    this.startTimer = this.startTimer.bind(this);
    this.getUserID = this.getUserID.bind(this);
    this.summaryCalculator = this.summaryCalculator.bind(this);
    this.changeColumnOrder = this.changeColumnOrder.bind(this);
    this.changeCurrentPage = this.changeCurrentPage.bind(this);
    this.changePageSize = this.changePageSize.bind(this);
    this.changeSorting = this.changeSorting.bind(this);
    this.changeSearchValue = this.changeSearchValue.bind(this);
    this.hiddenColumnNamesChange = this.hiddenColumnNamesChange.bind(this);
    this.generateTableData = this.generateTableData.bind(this);
    this.printExcelReport = this.printExcelReport.bind(this);
    this.printPdfReport = this.printPdfReport.bind(this);
    this.toggleReport = this.toggleReport.bind(this);
    this.ddlreporttypeOnChange = this.ddlreporttypeOnChange.bind(this);
    this.getUserID();
  }

  getUserID() {
    AxiosInstance({
      method: 'post',
      url: 'tbSYS_m_User/GetUserID',
    })
      .then((response) => {
        this.setState({ tbSYSmUserID: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  toggleReport() {
    this.setState({
      modalreport: !this.state.modalreport
    });

  }

  changeColumnOrder(newOrder) {
    this.setState({ columnOrder: newOrder });
  }

  hiddenColumnNamesChange = (hiddenColumnNames) => {
    this.setState({ hiddenColumnNames });
  };

  changeSearchValue(search_value) {
    var formatted_string = "";
    //formatted_string = search_value.replace(/[^a-zA-Z0-9 ]/g, "");
    formatted_string = search_value.replace(/['"]/g, '');

    if (formatted_string != this.state.filters) {
      clearInterval(this.searchCountdownTimer);

      this.setState({
        filters: formatted_string,
        seconds: 5
      });

      this.startTimer();
    }
  }

  changeSorting(sorting) {
    this.setState({
      column_name: sorting[0].columnName,
      order_by: sorting[0].direction,
      sorting: sorting
    });

    this.generateTableData(sorting[0].columnName, sorting[0].direction, this.state.currentPage, this.state.pageSize, this.state.filters);
  }

  changePageSize(currentSize) {

    var pageData = currentSize;
    var currentDataCount = this.state.pageSize * this.state.currentPage;
    var currentPage = Math.floor(currentDataCount / pageData);

    this.setState({
      loading: true,
      pageSize: pageData,
      currentPage: currentPage
    });

    this.generateTableData(this.state.column_name, this.state.order_by, currentPage, pageData, this.state.filters);
  }

  changeCurrentPage(currentPage) {
    var data = currentPage
    this.setState({
      loading: true,
      currentPage: data,
    });

    this.generateTableData(this.state.column_name, this.state.order_by, data, this.state.pageSize, this.state.filters);
  }

  summaryCalculator = (type, rows, getValue) => {
    if (type === 'count') {
      return this.state.totalCount;
    }
    return IntegratedSummary.defaultCalculator(type, rows, getValue);
  };

  generateTableData(column_name, orderby, currentPage, pageSize, filters) {
    var self = this;

    AxiosInstance({
      method: 'POST',
      url: 'tbBCM_m_Department/usp_tbBCM_m_Department_SelectDashboardBCMProfile_V12',
      withCredentials: true,
      errorHandler: true,
      data: {
        column_name: column_name,
        orderby: orderby,
        PageIndex: currentPage,
        PageSize: pageSize,
        keywords: filters,
        SelectedData: this.state.tbBCMmDepartmentID
      }
    })
      .then(response => {
        this.setState({
          rows: []
        })
        if (response != 'undefined' && response != undefined) {
          if (response.data.length > 0) {

            var new_rows = [];
            for (let response_data of response.data) {
              var new_data = response_data;
              new_data["departmentName"] = <a href="javascript:void(0)" onClick={() => this.redirect(response_data)}>{new_data["departmentName"]}</a>;
              new_rows.push(new_data);
            }

            this.setState({
              rows: new_rows.length != 0 ? new_rows : '',
              totalCount: response.data.length != 0 ? response.data[0]["totalRow"] : 0,
              loading: false,
            })
          }
        }
      })
      .catch(function (error) {
        //     console.log(error);
      });
  }

  redirect(new_data) {



    sessionStorage.setItem("NewQRadar_tbBCMmDepartmentID", new_data.tbBCMmDepartmentID)
    sessionStorage.setItem('NewQRadar_scoreCard', new_data.departmentName.props.children);
    sessionStorage.setItem('NewQRadar_tbWFLtBCMTransactionID', -1);
    sessionStorage.setItem('NewQRadar_readOnly', new_data.readOnly);
    sessionStorage.setItem('NewQRadar_writeOnly', new_data.writeOnly);
    sessionStorage.setItem('NewQRadar_deleteOnly', new_data.deleteOnly);
    sessionStorage.setItem('NewQRadar_reportOnly', new_data.reportOnly);

    this.checkWorkFlow(new_data.tbBCMmDepartmentID)



  }

  checkWorkFlow(dptID) {
    if (dptID != "") {
      AxiosInstance({
        method: 'POST',
        url: 'tbWFL_t_BCMTransaction/usp_tbWFL_t_BCMTransaction_SelectWFLStatusByDeptIDEx_V12',
        withCredentials: true,
        errorHandler: true,
        data: {
          dctbBCMmDepartmentID: dptID
        }
      })
        .then(response => {

          sessionStorage.setItem('NewQRadar_BCMDisableDepartment', response.data.disableScreen);

          if (window.location.hash === '#/bcmuser/scorecardmasterselection') {
            window.location.hash = "/bcmuser/departmentinfo/departmentinfolist";
          } else if (window.location.href.includes('?')) {
            window.history.go(-1);
          } else {
            window.location.reload();
          }


        })
        .catch(function (error) {

        });
    } else {
      if (window.location.hash === '#/bcmuser/scorecardmasterselection') {
        window.location.hash = "/bcmuser/departmentinfo/departmentinfolist";
      } else if (window.location.href.includes('?')) {
        window.history.go(-1);
      } else {
        window.location.reload();
      }
    }
  }

  printExcelReport() {

    var self = this;
    self.setState({
      loading: true
    })

    var report = new window.Stimulsoft.Report.StiReport();

    if (process.env.REACT_APP_PRODUCTION_ENV == true) {
      report.loadFile(process.env.PUBLIC_URL + "/template/BCMProfileReport.xml");
    } else {
      // production code
      report.loadFile(process.env.PUBLIC_URL + "/template/BCMProfileReport.mrt");
    }


    //// Render report

    var array = [];

    array.push({
      parameter: 'sSelectedData',
      value: this.state.tbBCMmDepartmentID,
    });
    array.push({
      parameter: 'dctbSYSmUserID',
      value: this.state.tbSYSmUserID,
    });

    for (var i = 0; i < report.dictionary.variables.list.length; i++) {
      var parameter = report.dictionary.variables.list[i].name;
      for (var j = 0; j < array.length; j++) {
        if (parameter == array[j].parameter) {
          report.setVariable(parameter, array[j].value);
        }
      }
    }


    window.StiOptions.WebServer.url = process.env.REACT_APP_WEBSERVER_URL;

    report.renderAsync(function (res) {
      ////// Export to Excel
      var settings = new window.Stimulsoft.Report.Export.StiExcel2007ExportSettings();
      // Create an PDF service instance.
      var service = new window.Stimulsoft.Report.Export.StiExcel2007ExportService();


      // Create a MemoryStream object.
      var stream = new window.Stimulsoft.System.IO.MemoryStream();
      // Export PDF using MemoryStream.
      service.exportExcel(report, stream, settings);

      // Get PDF data from MemoryStream object
      var data = stream.toArray();
      // Get report file name
      var fileName = 'BCM Profile Report';
      // Save data to file
      Object.saveAs(data, fileName + ".xls", "application/vnd.ms-excel");
      self.setState({
        loading: false
      })
    });
  }

  printPdfReport() {

    var self = this;
    self.setState({
      loading: true
    })

    var report = new window.Stimulsoft.Report.StiReport();

    if (process.env.REACT_APP_PRODUCTION_ENV == true) {
      report.loadFile(process.env.PUBLIC_URL + "/template/BCMProfileReport.xml");
    } else {
      // production code
      report.loadFile(process.env.PUBLIC_URL + "/template/BCMProfileReport.mrt");
    }


    //// Render report

    var array = [];

    array.push({
      parameter: 'sSelectedData',
      value: this.state.tbBCMmDepartmentID,
    });
    array.push({
      parameter: 'dctbSYSmUserID',
      value: this.state.tbSYSmUserID,
    });

    for (var i = 0; i < report.dictionary.variables.list.length; i++) {
      var parameter = report.dictionary.variables.list[i].name;
      for (var j = 0; j < array.length; j++) {
        if (parameter == array[j].parameter) {
          report.setVariable(parameter, array[j].value);
        }
      }
    }


    window.StiOptions.WebServer.url = process.env.REACT_APP_WEBSERVER_URL;

    report.renderAsync(function (res) {
      var settings = new window.Stimulsoft.Report.Export.StiPdfExportSettings();
      // Create an PDF service instance.
      var service = new window.Stimulsoft.Report.Export.StiPdfExportService();


      // Create a MemoryStream object.
      var stream = new window.Stimulsoft.System.IO.MemoryStream();
      // Export PDF using MemoryStream.
      service.exportTo(report, stream, settings);

      // Get PDF data from MemoryStream object
      var data = stream.toArray();
      // Get report file name
      var fileName = 'BCM Profile Report';
      // Save data to file
      Object.saveAs(data, fileName + ".pdf", "application/pdf");
      self.setState({
        loading: false
      })
    });
  }

  ddlreporttypeOnChange(selectedValue) {
    this.setState({ ddlreporttypeselectedvalue: selectedValue.value });
  }

  startTimer() {
    this.searchCountdownTimer = setInterval(() => {
      const { seconds } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1
        }))
      }

      if (seconds === 0) {
        clearInterval(this.searchCountdownTimer);

        this.generateTableData(this.state.column_name, this.state.order_by, this.state.currentPage, this.state.pageSize, this.state.filters);
      }
    }, 100);
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    clearInterval(this.searchCountdownTimer);
  }

  render() {
    let ScorecardSelection;
    if (window.location.href.includes('?') == false) {
      ScorecardSelection = <div className="col-lg-8 col-md-8 col-sm col-xs "><Label data-langid="9531.01">Response Plan Master Selection</Label></div>;
    }
    else {
      ScorecardSelection = "";
    }

    return (

      <React.Fragment>
        <Card>
          <CardHeader className="table-card align-items-center">
            {ScorecardSelection}
            {/*<Button className="form-btn mr-1" onClick={this.printExcelReport} color="primary"><i class="fa fa-lg fa-file-excel-o" aria-hidden="true"> Excel</i></Button>
              <Button className="form-btn pull-right" onClick={this.printPdfReport} color="primary"><i class="fa fa-lg fa-file-pdf-o" aria-hidden="true"> PDF</i></Button>*/}
          </CardHeader>
          <CardBody>
            <div>
              <Grid
                rows={this.state.rows}
                columns={this.state.columns}
              >

                <PagingState
                  currentPage={this.state.currentPage}
                  onCurrentPageChange={this.changeCurrentPage}
                  pageSize={this.state.pageSize}
                  onPageSizeChange={this.changePageSize}
                />

                <SummaryState
                  totalItems={this.state.totalSummaryItems}
                />
                <CustomPaging
                  totalCount={this.state.totalCount}
                />

                <SortingState
                  sorting={this.state.sorting}
                  onSortingChange={this.changeSorting}
                />

                <SearchState
                  value={this.state.filters}
                  onValueChange={this.changeSearchValue}
                />
                <IntegratedSummary calculator={this.summaryCalculator} />
                <DragDropProvider />
                <Table columnExtensions={this.state.tableColumnExtensions} />
                <TableHeaderRow showSortingControls />
                <TableSummaryRow formatlessSummaryTypes={formatlessSummaryTypes}
                  messages={messages} />

                <TableColumnVisibility
                  hiddenColumnNames={this.state.hiddenColumnNames}
                  onHiddenColumnNamesChange={this.hiddenColumnNamesChange}
                />

                <TableColumnReordering
                  order={this.state.columnOrder}
                  onOrderChange={this.changeColumnOrder}
                />

                <Toolbar />
                <ColumnChooser />
                <SearchPanel />
                <PagingPanel
                  pageSizes={this.state.pageSizes} />

              </Grid>
              {this.state.loading && <Loading />}
            </div>
          </CardBody>
        </Card>

      </React.Fragment>
    );
  }
}

export default BCMProfile;
